const getTabStyle = (color: string, transparentBackground: boolean) => {
  return {
    root: {
      borderBottom: 1,
      borderColor: 'divider',
      display: 'flex',
      width: '100%',
      backgroundColor: transparentBackground ? 'transparent' : 'white',
    },
    tabs: {
      '& .MuiTab-root.Mui-selected': {
        color: color,
      },
      '& .MuiTabs-indicator': {
        backgroundColor: color,
      },
    },
    tab: {
      textTransform: 'capitalize',
      fontSize: '16px',
      fontWeight: 500,
      minWidth: '60px',
    },
  };
};

export default getTabStyle;
